/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './section-category.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/shared/pipes/unescape-cache-pipe';
import * as import5 from '../../../../app/shared/services/stringutils';
import * as import6 from '../../../../app/category/section/section-category.component';
import * as import7 from '@angular/platform-browser';
const styles_SectionCategoryComponent:any[] = [import0.styles];
export const RenderType_SectionCategoryComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_SectionCategoryComponent,
  data: {}
}
);
function View_SectionCategoryComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),26,'a',[[
        'class',
        'undecorated'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'd-flex flex-column flex-md-row section-bottom-separator first-level section-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image left-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'excerpt align-items-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import1.ɵinlineInterpolate(1,'',((co.articles[0] == null)? (null as any): co.articles[0].url),'');
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵnov(v,1).target;
    const currVal_1:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',((co.articles[0] == null)? (null as any): co.articles[0].unbrandedImage),'');
    ck(v,7,0,currVal_3);
    const currVal_4:any = import1.ɵinlineInterpolate(1,'',((co.articles[0] == null)? (null as any): co.articles[0].id),'');
    ck(v,12,0,currVal_4);
    const currVal_5:any = ((co.articles[0] == null)? (null as any): co.articles[0].title);
    ck(v,13,0,currVal_5);
    const currVal_6:any = import1.ɵunv(v,16,0,ck(v,17,0,import1.ɵnov((<any>v.parent),0),((co.articles[0] == null)? (null as any): co.articles[0].tag)));
    ck(v,16,0,currVal_6);
    const currVal_7:any = import1.ɵunv(v,21,0,ck(v,22,0,import1.ɵnov((<any>v.parent),1),((co.articles[0] == null)? (null as any): co.articles[0].excerpt)));
    ck(v,21,0,currVal_7);
  });
}
function View_SectionCategoryComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),20,'a',[[
        'class',
        'undecorated'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'excerpt'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import1.ɵinlineInterpolate(1,'',((co.articles[1] == null)? (null as any): co.articles[1].url),'');
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵnov(v,1).target;
    const currVal_1:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',((co.articles[1] == null)? (null as any): co.articles[1].id),'');
    ck(v,3,0,currVal_3);
    const currVal_4:any = ((co.articles[1] == null)? (null as any): co.articles[1].title);
    ck(v,4,0,currVal_4);
    const currVal_5:any = import1.ɵunv(v,7,0,ck(v,8,0,import1.ɵnov((<any>v.parent),0),((co.articles[1] == null)? (null as any): co.articles[1].tag)));
    ck(v,7,0,currVal_5);
    const currVal_6:any = import1.ɵinlineInterpolate(1,'',((co.articles[1] == null)? (null as any): co.articles[1].unbrandedImage),'');
    ck(v,12,0,currVal_6);
    const currVal_7:any = import1.ɵunv(v,17,0,ck(v,18,0,import1.ɵnov((<any>v.parent),1),((co.articles[1] == null)? (null as any): co.articles[1].excerpt)));
    ck(v,17,0,currVal_7);
  });
}
function View_SectionCategoryComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'a',[[
        'class',
        'undecorated'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,1).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'd-flex flex-column section-part section-bottom-separator decorated-box top-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          VIDEOS\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[
      [
        'class',
        'icon-video'
      ]
      ,
      [
        'height',
        '80px'
      ]
      ,
      [
        'width',
        '80px'
      ]

    ]
      ,[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import1.ɵinlineInterpolate(1,'',((co.insuranceCostGuide == null)? (null as any): co.insuranceCostGuide.url),'');
    ck(v,1,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵnov(v,1).target;
    const currVal_1:any = import1.ɵnov(v,1).href;
    ck(v,0,0,currVal_0,currVal_1);
    const currVal_3:any = import1.ɵinlineInterpolate(1,'',((co.insuranceCostGuide == null)? (null as any): co.insuranceCostGuide.id),'');
    ck(v,5,0,currVal_3);
    const currVal_4:any = ((co.insuranceCostGuide == null)? (null as any): co.insuranceCostGuide.title);
    ck(v,6,0,currVal_4);
    const currVal_5:any = import1.ɵinlineInterpolate(1,'/images/icons/',((co.articles[1] == null)? (null as any): co.articles[1].categoryId),'-video.png');
    ck(v,11,0,currVal_5);
  });
}
export function View_SectionCategoryComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵpid(0,import3.UpperCasePipe,([] as any[])),
    import1.ɵpid(0,import4.UnescapeCachePipe,[import5.StringUtils]),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SectionCategoryComponent_1)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'd-flex flex-md-row flex-column section-bottom-separator second-level'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'd-flex flex-column section-part section-right-separator left-part justify-content-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SectionCategoryComponent_2)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SectionCategoryComponent_3)),
    import1.ɵdid(16384,(null as any),0,import3.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'a',[
      [
        'routerLink',
        '/cost-of-living/ny/new-york'
      ]
      ,
      [
        'style',
        'overflow: hidden;'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,19).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'section-part maps bottom-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'd-flex flex-md-row flex-column section-bottom-separator third-level'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'd-flex flex-column section-part section-right-separator left-part justify-content-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'a',[[
        'class',
        'undecorated'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,32).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n      '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'img-fluid'
      ]
      ],[[
        8,
        'src',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'class',
        'd-flex flex-column right-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),11,'a',[[
        'class',
        'undecorated'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,51).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'd-flex flex-column block-part'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'title hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'tag'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          COST GUIDES\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import6.SectionCategoryComponent = v.component;
    const currVal_0:any = co.articles[0];
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.articles[1];
    ck(v,10,0,currVal_1);
    const currVal_2:any = co.insuranceCostGuide;
    ck(v,16,0,currVal_2);
    const currVal_5:any = '/cost-of-living/ny/new-york';
    ck(v,19,0,currVal_5);
    const currVal_8:any = import1.ɵinlineInterpolate(1,'',((co.articles[2] == null)? (null as any): co.articles[2].url),'');
    ck(v,32,0,currVal_8);
    const currVal_15:any = import1.ɵinlineInterpolate(1,'',((co.homeImprovementCostGuide == null)? (null as any): co.homeImprovementCostGuide.url),'');
    ck(v,51,0,currVal_15);
  },(ck,v) => {
    var co:import6.SectionCategoryComponent = v.component;
    const currVal_3:any = import1.ɵnov(v,19).target;
    const currVal_4:any = import1.ɵnov(v,19).href;
    ck(v,18,0,currVal_3,currVal_4);
    const currVal_6:any = import1.ɵnov(v,32).target;
    const currVal_7:any = import1.ɵnov(v,32).href;
    ck(v,31,0,currVal_6,currVal_7);
    const currVal_9:any = import1.ɵinlineInterpolate(1,'',((co.articles[2] == null)? (null as any): co.articles[2].id),'');
    ck(v,34,0,currVal_9);
    const currVal_10:any = ((co.articles[2] == null)? (null as any): co.articles[2].title);
    ck(v,35,0,currVal_10);
    const currVal_11:any = import1.ɵunv(v,38,0,ck(v,39,0,import1.ɵnov(v,0),((co.articles[2] == null)? (null as any): co.articles[2].tag)));
    ck(v,38,0,currVal_11);
    const currVal_12:any = import1.ɵinlineInterpolate(1,'',((co.articles[2] == null)? (null as any): co.articles[2].unbrandedImage),'');
    ck(v,43,0,currVal_12);
    const currVal_13:any = import1.ɵnov(v,51).target;
    const currVal_14:any = import1.ɵnov(v,51).href;
    ck(v,50,0,currVal_13,currVal_14);
    const currVal_16:any = import1.ɵinlineInterpolate(1,'',((co.homeImprovementCostGuide == null)? (null as any): co.homeImprovementCostGuide.id),'');
    ck(v,55,0,currVal_16);
    const currVal_17:any = ((co.homeImprovementCostGuide == null)? (null as any): co.homeImprovementCostGuide.title);
    ck(v,56,0,currVal_17);
  });
}
function View_SectionCategoryComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'sectionCategory',([] as any[]),(null as any),(null as any),(null as any),View_SectionCategoryComponent_0,RenderType_SectionCategoryComponent)),
    import1.ɵdid(49152,(null as any),0,import6.SectionCategoryComponent,[import7.DOCUMENT],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SectionCategoryComponentNgFactory:import1.ComponentFactory<import6.SectionCategoryComponent> = import1.ɵccf('sectionCategory',import6.SectionCategoryComponent,View_SectionCategoryComponent_Host_0,{
  articles: 'articles',
  insuranceCostGuide: 'insuranceCostGuide',
  homeImprovementCostGuide: 'homeImprovementCostGuide'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/category/section/section-category.component.ngfactory.ts